.noResults {
    margin-top: var(--exo-spacing-medium);
    display: flex;
    justify-content: center;
}
